export default "__VITE_ASSET__BOTeE8UZ__"